import React, { PureComponent } from 'react';
import { Card, Button, Row, Col, Container } from 'react-bootstrap';
import Spinner from '../subcomponent/spinner';
import extractInfo from '../../middleware/extractInfo';
import { CSVLink } from "react-csv";
import Menu from '../menu';

export default class cargaTerceros extends PureComponent {
    constructor(props) {
        super(props)
        this.uploadTxtFile = this.uploadTxtFile.bind(this);
        this.uploadCsvFile = this.uploadCsvFile.bind(this);
        this.state = {
            csvData: [],
            txtData: [],
            loadingCsv: false,
            loadingText: false
        }
    }
    uploadTxtFile(event) {
        this.setState({ loadingCsv: true });
        const callback = this.terminadoCsv;
        let tmp = [];
        const cabecera = extractInfo.processCabeceraTerceros();
        tmp.push(cabecera);
        //callback(tmp);
        const fileReader = new FileReader();
        const file = event.target.files[0];
        //let tmp = [];
        fileReader.readAsText(file);

        fileReader.onloadend = function () {
            // By lines
            const lines = this.result.split('\n');

            lines.forEach((element, i) => {
                if (element.substring(6, 8) === "01" || element.substring(6, 8) === "99") {
                    const data = extractInfo.processLineTerceros(element);
                    tmp.push(data);
                }
            });
            callback(tmp);
        }
    }

    uploadCsvFile(event) {
        this.setState({ loadingText: true });
        const callback = this.terminadoText;
        const fileReader = new FileReader();
        const file = event.target.files[0];
        let tmp = "";
        fileReader.readAsText(file);

        fileReader.onloadend = function () {
            // By lines
            const rows = this.result.split("\n");
            let data = [];
            rows.forEach((element, i) => {
                if (i > 0) {
                    let limpieza = element.replace(/"/g, '');
                    if (limpieza.search(";") > 0) data = limpieza.split(";");
                    if (limpieza.search("\t") > 0) data = limpieza.split("\t");
                    //if (limpieza.search(",") > 0) data = limpieza.split(",");
                    if (Number(data[0]) === 99 || Number(data[0]) === 1) {
                        const finalData = extractInfo.processFormatCadena(data, i);
                        tmp += finalData;
                    }
                }
            });
            callback(tmp);
        }
    }

    terminadoCsv = (tmp) => {
        this.setState({ loadingCsv: false, csvData: tmp });
    }

    terminadoText = (tmp) => {
        const now = new Date();
        const year = now.getFullYear().toString();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString();
        const name = "001" + year.substr(3, 1) + month + day + ".TE9";
        
        const element = document.createElement("a");
        const file = new Blob([tmp], { type: 'text/plain;charset=utf-8' });
        element.href = URL.createObjectURL(file);
        element.download = name;
        document.body.appendChild(element);
        element.click();

        this.setState({ loadingText: false });
    }

    render() {
        const { csvData } = this.state;
        const { loadingText } = this.state;
        const { loadingCsv } = this.state;
        return (
            <div>
                <Menu></Menu>
                <h3 className="m-5 ">Proceso de actualizacion de terceros en el sistema CGUNO</h3>
                <Container >
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Carga archivo del TRM</h4>
                                        <Col className="mb-2">
                                            <input type="file" name="myFile" accept=".TE?" onChange={this.uploadTxtFile} className="btn btn-primary" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="mb-2">
                                            {(loadingCsv) && <Spinner loading={loadingCsv} />}
                                            {(!loadingCsv && csvData.length > 0) && <CSVLink data={csvData} filename={"TERCEROS.csv"} separator={";"}>
                                                <Button variant="success">Descargar Excel</Button>
                                            </CSVLink>}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Proceso Generador Plano Actualizado</h4>
                                        <Col className="mb-2">
                                            <input type="file" name="myxlsFile" accept=".csv" onChange={this.uploadCsvFile} className="btn btn-primary" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="mb-2">
                                            {(loadingText) && <Spinner loading={loadingText} />}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <p>
                            1. Generar el archivo de transmision desde el modulo
                        M -> Mantenimineto -> Comercial -> Transmision de Catalgos -> Terceros <br />
                        2. Entrar a la carpeta TRM y validar la creacion del archivo <br />
                        3. Cargar el archivo generado en la opcion "Carga archivo del TRM" <br />
                        4. Presionar el boton de Descargar Excel <br />
                        5. Editar Archivo de Excel Nota: Si solo desea actualizar regimen y responsabilidad, debe editar la columna T y la columna U<br />
                        6. Guardar los cambios realizados en el Excel (Guardar como CSV delimitado por coma) <br />
                        7. Cargar archivo de Excel modificado en la opcion "Generador de archivo actualizado" <br />
                        8. Copiar el archivo descargado desde la plataforma en la carpeta TRM <br />
                        9. Recepcionar el archivo al sistema CGUNO
                        M -> Mantenimineto -> Comercial -> Recepcion de Catalgos -> Terceros <br />
                        10. Seleccionamos el archivo para cargar desde el CGUNO <br />
                        </p>
                    </Row>
                </Container>
            </div>
        )
    }
}
